/* eslint-disable */
import {gsap} from "gsap";

window.addEventListener('load', () => {
  TimelineBlock.init();
});

const TimelineBlock = {
  init: function () {
    const sections = document.querySelectorAll('[data-timeline-block-js]');

    if (!sections.length) return;

    sections.forEach((section) => {
      this.initSection(section)
    })

  },

  initSection: function (section) {
    let svgAreas = section.querySelectorAll('[data-svg-area-js]');
    if (!svgAreas.length) return;

    svgAreas.forEach((svgArea) => {
      let svgWrap = svgArea.querySelector('[data-svg-wrap-js]');
      let svgCloneWrap = svgArea.querySelector('[data-svg-clone-wrap-js]');
      if(!svgWrap || !svgCloneWrap) return;
      let svgClone = svgCloneWrap.innerHTML;

      let svgAnim = gsap.timeline({
        immediateRender: false,

        scrollTrigger: {
          trigger: svgArea,
          start: 'top bottom',
          end: '50% bottom',
          scrub: 0,
          // markers: true,
          onLeave: self => {
            if(svgWrap.innerHTML === ''){
              svgWrap.innerHTML = svgClone;
            }
          },
          onLeaveBack: () => {
            svgWrap.innerHTML = '';
          }
        }
      });
    })
  },

}

export default TimelineBlock;
